import React, { useState, useEffect, useRef, useCallback } from "react"
import { useSelector, useDispatch } from "react-redux"
import Form from "react-bootstrap/Form"
import Button from "react-bootstrap/Button"
import Spinner from "react-bootstrap/Spinner"

import { getClientEmailTemplates, restoreDefaultEmailTemplate, updateClientEmailTemplate } from "../../state/clientEmailsSlice"
import debounce from "lodash.debounce"

function EmailTemplate({ emailBody }) {

    const [editEmailBody, setEditEmailBody] = useState("")
    const isLoadingEmail = useSelector(state => state.clientEmails.isLoadingEmail)
    const [selectionStart, setSelectionStart] = useState(0)

    let dispatch = useDispatch();

    const messageRef = useRef()


    // UseEffects 
    useEffect(() => {
        setEditEmailBody(emailBody);
    }, [emailBody])


    messageRef?.current?.addEventListener('keyup', e => {
        setSelectionStart(e.target.selectionStart)
    })

    const addAutoMessageTag = (tagType) => {
        const tag = `[${tagType}]`;
        const bodyUpdate = `${editEmailBody.substring(0, selectionStart)}${tag}${editEmailBody.substring(selectionStart)}`
        setSelectionStart(selectionStart + tag.length)
        setEditEmailBody(bodyUpdate)
        debouncedUpdateClientEmailTemplate({
            email_type_id: "1",
            email_body: bodyUpdate,
        })
        messageRef.current.focus()
    }

    // debounce the database email body update function
    const debouncedUpdateClientEmailTemplate = useCallback(debounce((payload) =>
        dispatch(updateClientEmailTemplate(payload)), 800), [])

    function handleEmailBodyChange(value) {
        setEditEmailBody(value);
        // debounce the database email body update
        debouncedUpdateClientEmailTemplate({
            email_type_id: "1",
            email_body: value,
        })
    }

    function handleRestoreOriginalTemplate() {
        if (window.confirm("Are you sure you want to restore the original email template? This action is permanent and not reversible.")) {
            dispatch(restoreDefaultEmailTemplate({
                email_type_id: "1"
            })
            ).then(res => {
                dispatch(getClientEmailTemplates({ email_type_id: "1" }))
            })
        }
    }

    return (
        <>
            <div style={{ fontSize: "22px" }} > <b> Welcome Email </b> </div>
            {/* email variable insert options */}
            {isLoadingEmail ? <Spinner className="mt-2" animation="border" role="status" variant="primary" />
                : <>
                    <small> <i className="fa fa-info-circle " /> You can insert the below optional placeholders. Placeholders  <br />
                        will auto-fill with relevant client information when the email is sent.</small>

                    <div className="d-flex mb-1">
                        <div className="d-md-flex w-75 mb-1 ">
                            <div>
                                <Button
                                    size="sm"
                                    variant="outline-success"
                                    className="p-1 m-1"
                                    onClick={() => addAutoMessageTag("client_first_name")}>
                                    Client First Name
                                </Button>
                                <Button
                                    size="sm"
                                    variant="outline-success"
                                    className="p-1 m-1"
                                    onClick={() => addAutoMessageTag("client_login_email")}>
                                    Client Login Email
                                </Button>
                            </div>
                            <div>
                                <Button
                                    size="sm"
                                    variant="outline-success"
                                    className="p-1 m-1"
                                    onClick={() => addAutoMessageTag("client_password")}>
                                    Client Password
                                </Button>
                            </div>

                        </div>
                        <div className="d-flex justify-content-end align-items-end w-25">
                            <Button size="sm" variant="outline-danger float-right" className="mb-2"
                                onClick={handleRestoreOriginalTemplate}>
                                Restore original template
                            </Button>

                        </div>
                    </div>
                    <div>
                        <Button
                            size="sm"
                            variant="outline-primary"
                            className="p-1 m-1"
                            onClick={() => addAutoMessageTag("IOS_link")}>
                            IOS App link
                        </Button>
                        <Button
                            size="sm"
                            variant="outline-primary"
                            className="p-1 m-1"
                            onClick={() => addAutoMessageTag("android_link")}>
                            Android App link
                        </Button>
                        <Button
                            size="sm"
                            variant="outline-primary"
                            className="p-1 m-1"
                            onClick={() => addAutoMessageTag("client_sign_in_link")}>
                            Client Sign in Link
                        </Button>
                    </div>


                    <div>
                        <Form.Control
                            ref={messageRef}
                            as="textarea"
                            rows={20}
                            style={{ whiteSpace: "pre-wrap" }}
                            value={editEmailBody}
                            onClick={e => {
                                setSelectionStart(e.target.selectionStart)
                            }}
                            onChange={(e) => {
                                handleEmailBodyChange(e.target.value);
                            }} />

                    </div>
                    <small className="float-right"> <i className="fa fa-info-circle " /> data is saved automatically</small>
                </>}
        </>

    )
}

export default EmailTemplate